export const SET_ORG_FILTER_LIST = "SET_ORG_FILTER_LIST";
export const SET_ORG_DISTRICT_LIST = "SET_ORG_DISTRICT_LIST";
export const SET_ORG_DISTRICT_ADMINS_LIST = "SET_ORG_DISTRICT_ADMINS_LIST";
export const SET_ORG_REQUEST = "SET_ORG_REQUEST";
